import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Slider from 'react-slick';

import BmcCanvasContainer from '../bmc/BmcCanvasContainer';
import Button from '../../components/Button';
import Spinner from '../../components/Spinner';
import Card from './Card';
import * as AppRoute from '../../utils/appRoutes';
import FirstTimeTip from '../tips/FirstTimeTip';
import { ENABLE_ONBOARDING } from '../../utils/const';

export default function index({ locales }) {
  const history = useHistory();
  const slick = useRef(null);

  const {
    list: {
      title,
      createNewIdea,
      createAnotherIdea,
      dontHaveBusinessIdea,
      letsBrainstorm,
    },
    intro: { card },
  } = locales.ideation;

  const {
    ideation: { collection, uploading },
    bmc: {
      current: currentBmc,
      current: { id: bmcId },
    },
  } = useSelector((state) => state);

  const {
    bmc: { setBmcView },
    ideation: { fetchIdeas, addIdea, removeIdea },
    user: { updateCurrentUser },
  } = useDispatch();

  useEffect(() => {
    setBmcView('');
  }, []);

  useEffect(() => {
    if (bmcId) {
      updateCurrentUser({ name: 'lastBmcId', value: bmcId });
      fetchIdeas();
    }
  }, [bmcId]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  async function addIdeaHandler() {
    const data = await addIdea();
    return data && history.push(AppRoute.ideation(bmcId, data.id));
  }

  const getIdeaData = (idea) => {
    const {
      data: { ideas, pickedIdeaId },
    } = idea;
    const pickedIdea = ideas && ideas.find((e) => e.id === pickedIdeaId);

    return pickedIdea || {};
  };

  const getCardData = (idea) => {
    return {
      ...card,
      url: null,
      problem: '',
      solution: '',
      marketSize: 0,
      price: 0,
      excitement: 0,
      ...getIdeaData(idea),
      id: idea.id,
    };
  };

  const handlePrevSlide = () => {
    if (slick.current) {
      slick.current.slickPrev();
    }
  };

  const handleNextSlide = () => {
    if (slick.current) {
      slick.current.slickNext();
    }
  };

  return (
    <BmcCanvasContainer locales={locales}>
      {ENABLE_ONBOARDING && (
        <FirstTimeTip page="ideation" tips="ideationTip" locales={locales} />
      )}
      <div className="bmc-main">
        <div className="bmc-main-header">
          <h1 className="bmc-main-header-title">{title}</h1>

          {collection.length > 0 && (
            <Button onClick={() => addIdeaHandler()}>
              {createAnotherIdea}
            </Button>
          )}
        </div>

        {uploading ? (
          <Spinner className="margin-top-60" big />
        ) : (
          <div className="ideation-list">
            {collection.length > 0 ? (
              <>
                <div className="ideation-list-items">
                  {collection.length > 1 && (
                    <button
                      onClick={handlePrevSlide}
                      className="ideation-list-items-arrow ideation-list-items-arrow--left"
                      aria-label="Previous idea"
                    >
                      <i className="icon-Arrow-Top" />
                    </button>
                  )}

                  {collection.length > 1 ? (
                    <Slider ref={slick} {...settings}>
                      {collection.map((idea) => (
                        <Card
                          card={getCardData(idea)}
                          bmc={currentBmc}
                          removeIdea={removeIdea}
                          key={idea.id}
                          className="ideation-card--white"
                          locales={locales}
                          showEditButton
                        />
                      ))}
                    </Slider>
                  ) : (
                    <Card
                      card={getCardData(collection[0])}
                      bmc={currentBmc}
                      removeIdea={removeIdea}
                      key={collection[0].id}
                      className="ideation-card--white"
                      locales={locales}
                      showEditButton
                    />
                  )}

                  {collection.length > 1 && (
                    <button
                      onClick={handleNextSlide}
                      className="ideation-list-items-arrow ideation-list-items-arrow--right"
                      aria-label={locales.common.nextIdea}
                    >
                      <i className="icon-Arrow-Top" />
                    </button>
                  )}
                </div>
              </>
            ) : (
              <div className="ideation-list-empty">
                <div className="ideation-list-empty-text">
                  {dontHaveBusinessIdea}
                </div>
                <div className="ideation-list-empty-text margin-bottom-40">
                  {letsBrainstorm}
                </div>
                <Button onClick={() => addIdeaHandler()}>
                  {createNewIdea}
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
    </BmcCanvasContainer>
  );
}
